import { SellersService } from 'app/providers/api/services';
import { useApiMutation } from 'shared/hooks/useApiMutation';

interface Args {
  refetchInvitedUsers: () => void;
}

const useSellerEditUser = ({ refetchInvitedUsers }: Args) => {
  const { mutate: sellerEditUser } = useApiMutation(
    ['sellerEditUser'],
    SellersService.sellerEditUser,
    { onSuccess: () => refetchInvitedUsers() },
  );

  return {
    sellerEditUser,
  };
};

export default useSellerEditUser;
